/**
 * Defer ResizeObserver work to the next animation frame so callbacks that
 * read/write layout do not re-enter observation in the same frame.
 */
export function onResizeObserverFrame(callback) {
  let frameId = 0;
  return (...args) => {
    if (frameId) return;
    frameId = requestAnimationFrame(() => {
      frameId = 0;
      callback(...args);
    });
  };
}

export function createResizeObserver(callback) {
  if (typeof ResizeObserver === 'undefined') return null;
  return new ResizeObserver(onResizeObserverFrame(callback));
}
